var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('el-button',{on:{"click":_vm.getFileData}},[_vm._v("获取上传文件")]),_vm._v(" "),_c('WebUpload',{attrs:{"fileNumLimit":_vm.fileNumLimit,"fileSize":_vm.fileSize,"chunkSize":_vm.chunkSize,"uploadSuffixUrl":_vm.uploadSuffixUrl,"options":_vm.options,"fileListData":_vm.tableData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87484310","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload.vue
// module id = null
// module chunks = 